import { EnvType } from "../services";
import { IApiClient } from "../api-client";
import { GetRightsByTitleIdResponse } from "../Types/get-rights-by-title-id-response";
import { RightType } from "../Types/right-type";
import { GetRightContractByDealExternalIdResponse } from "../Types/get-right-contract-by-deal-external-id-response";
import { GetRightContractsByCustomerIdResponse } from "../Types/get-right-contracts-by-customer-id-response";
import { GetRightContractsResponse } from "../Types/get-right-contracts-response";
import { GetRightContractResponse } from "../Types/get-right-contract-response";

interface IRightApiClient {
  GetRightContractByTitleId(titleId: number, type: RightType): Promise<GetRightsByTitleIdResponse>;
  GetRightContractsByDealExternalId(externalDealId: string): Promise<GetRightContractByDealExternalIdResponse>;
  GetRightContractsByCustomerId(customerId: number): Promise<GetRightContractsByCustomerIdResponse>;
  GetRightContractById(Id: number): Promise<GetRightContractResponse>;
  GetRightContracts(maxItems: number): Promise<GetRightContractsResponse>;
}
export default class RightApiClient implements IRightApiClient {
  readonly servicePort = 9525;
  readonly serviceBaseUrl = "right-service/api";

  rightApiClient: IApiClient;

  constructor(rightApiClient: IApiClient, envType: EnvType) {
    this.rightApiClient = rightApiClient;
    if (envType === "local") this.rightApiClient.client.defaults.baseURL += `${this.servicePort}/`;
  }

  async GetRightContractByTitleId(titleId: number, type: RightType): Promise<GetRightsByTitleIdResponse> {
    return await this.rightApiClient.get(`${this.serviceBaseUrl}/rights/titles/${titleId}/${type}`);
  }
  async GetRightContractsByDealExternalId(externalDealId: string): Promise<GetRightContractByDealExternalIdResponse> {
    return await this.rightApiClient.get(`${this.serviceBaseUrl}/rights/deals/${externalDealId}`);
  }
  async GetRightContractsByCustomerId(customerId: number): Promise<GetRightContractsByCustomerIdResponse> {
    return await this.rightApiClient.get(`${this.serviceBaseUrl}/rights/customers/${customerId}`);
  }
  async GetRightContractById(id: number): Promise<GetRightContractResponse> {
    return await this.rightApiClient.get(`${this.serviceBaseUrl}/rights/${id}`);
  }
  async GetRightContracts(maxItems: number): Promise<GetRightContractsResponse> {
    return await this.rightApiClient.get(`${this.serviceBaseUrl}/rights/max/${maxItems}`);
  }

  //------Utils------
  GetApiUrl(): string {
    return this.rightApiClient.client.defaults.baseURL + this.serviceBaseUrl;
  }
}
